import SchoolsFilter from '@/components/SchoolsFilter';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useCallback, useEffect, useMemo } from 'react';
import { useReportingToolsStore } from '../../store/useReportingToolsStore';
import { useQuery } from '@apollo/client';
import { FetchMySchoolsQuery, FetchMySchoolsQueryVariables, FETCH_MY_SCHOOLS } from '@edwin-group/cj-graphql';

export const MainFilters = () => {
  const filters = useReportingToolsStore((state) => state.filters);
  const updateFilters = useReportingToolsStore((state) => state.updateFilters);
  const page = useReportingToolsStore((state) => state.page);
  const { data } = useQuery<FetchMySchoolsQuery, FetchMySchoolsQueryVariables>(FETCH_MY_SCHOOLS, {
    variables: {
      asRegularUser: true,
    },
  });

  useEffect(() => {
    if (data) {
      updateFilters({ ...filters, schoolDocumentIds: data.fetchMySchools?.map((school) => school.documentId!) || [] });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const generateAcademicYearsFromStartYearToCurrentYear = useCallback(() => {
    const startYear = 2024;
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(`${year}/${year + 1}`);
    }
    return years;
  }, []);

  const academicYears = useMemo(
    () => generateAcademicYearsFromStartYearToCurrentYear(),
    [generateAcademicYearsFromStartYearToCurrentYear],
  );

  return (
    <div className="mt-sh-30 flex gap-4">
      <div className="grow">
        <label className="text-sh-xxs font-bold" htmlFor="schools-filter">
          {page?.filters?.schools || ''}
        </label>
        <SchoolsFilter
          id="schools-filter"
          selectedSchoolsIds={filters.schoolDocumentIds}
          onChange={(schoolDocumentIds) => {
            updateFilters({ ...filters, schoolDocumentIds, cohortDocumentIds: [] });
          }}
          className="w-full"
        />
      </div>
      <div className="grow">
        <label className="text-sh-xxs font-bold" htmlFor="academic-year-filter">
          {page?.filters?.academicYear || ''}
        </label>
        <Select
          onValueChange={(option) => {
            updateFilters({ ...filters, academicYear: option });
          }}
          defaultValue={filters.academicYear}>
          <SelectTrigger className="h-[46px]">
            <SelectValue placeholder={page?.filters?.schoolsPlaceholder || ''} />
          </SelectTrigger>
          <SelectContent>
            {academicYears?.map((option) => {
              return (
                <SelectItem key={option} value={option}>
                  {option}
                </SelectItem>
              );
            })}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
